module.exports = __webpack_public_path__ + "static/media/  (90).12d3c3f3.jpg";